import styled, { css } from 'styled-components';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
// components
import BothHeader from 'components/layout/headers/Both';
import IconButton from 'cds/buttons/Icon';
import Icon from 'cds/icons';
import MainLayout from 'cds/layout/Main';
import Layout from 'components/layout';
// components
import HorizontalSlider from 'components/molecules/common/HorizontalSlider';
import OutlineButton from 'cds/buttons/Outline';
// hooks
import useMetaData from 'hooks/common/useMetaData';
import useCommonBridge from 'hooks/bridge/useCommonBridge';
// styles
import { mediaQuery, palette, onlyHover } from 'cds/styles';

const itemList = ['2022.01.03', '2021.11.02', '2021.08.05', '2021.01.01'];

/** 이용약관 페이지 */
const AgreementPage = () => {
  const [Content, setContent] = useState(null);
  const [item, setItem] = useState(itemList[0]);

  const { MetaTitle } = useMetaData();

  const ItemList = itemList.map((v, idx) => {
    const name = v.replace(/\./gi, '');
    const Component = dynamic(() => import(`./${name}`));

    const onClick = () => {
      setContent(Component);
      setItem(v);
    };

    return (
      <li key={idx}>
        <TagButton selected={item === v} onClick={onClick}>
          {v}
        </TagButton>
      </li>
    );
  });

  useEffect(() => {
    const Component = dynamic(() => import(`./${itemList[0].replace(/\./g, '')}`));
    setContent(Component);
  }, []);

  return (
    <>
      <MetaTitle content="이용약관" />

      <Wrapper>
        <TagWrapper>
          <HorizontalSlider>{ItemList}</HorizontalSlider>
        </TagWrapper>
        {!!Content && <Content />}
      </Wrapper>
    </>
  );
};

const Header = () => {
  const router = useRouter();

  const { onCloseWebView } = useCommonBridge();

  const onBack = () => {
    if (!onCloseWebView()) {
      router.back();
    }
  };

  return (
    <BothHeader
      message={`이용약관`}
      leftSide={
        <IconButton width={24} height={54} onClick={onBack}>
          <Icon
            name="ic_back_m"
            width={24}
            height={24}
            fill={palette.grey75}
            stroke={palette.grey75}
          />
        </IconButton>
      }
    />
  );
};

AgreementPage.getLayout = function getLayout(page) {
  return <Layout mobileHeader={<Header />}>{page}</Layout>;
};

const Wrapper = styled(MainLayout)`
  width: 1800px;
  padding: 24px 16px;
  counter-reset: policy-counter;

  ${mediaQuery.large} {
    padding: 48px 72px 64px;
  }
`;

const TagWrapper = styled.div`
  width: 1800px;
  max-width: 100%;
  padding: 0 0 32px;
  margin: 0 auto;

  & ul {
    padding: 0;
  }

  & li {
    & ~ * {
      margin-left: 8px;
    }
  }

  ${mediaQuery.xlarge} {
    padding: 0 0 48px;
  }
`;

const TagButton = styled(OutlineButton)`
  flex-grow: 0;
  height: 32px;
  padding: 0 12px;
  white-space: nowrap;
  border-radius: 32px;
  border: ${({ selected }) =>
    selected ? `1px solid ${palette.BTN.BG}` : `1px solid ${palette.system.grey}`};
  background-color: ${({ selected }) => (selected ? palette.BTN.BG : 'transparent')};
  color: ${({ selected }) => (selected ? palette.grey75 : palette.grey50)};
  font-size: 12px;

  &::before {
    z-index: 0;
    border-radius: 32px;
  }

  & > div {
    padding-right: 8px;
    margin-left: 4px;
    z-index: 1;
  }

  ${onlyHover} {
    &:hover {
      ${({ disabled }) =>
        !disabled &&
        css`
          &::before {
            background-color: rgba(0, 0, 0, 0.04);
          }
        `};
    }
  }

  &:active {
    ${({ disabled }) =>
      !disabled &&
      css`
        &::before {
          background-color: rgba(0, 0, 0, 0.04);
        }
      `};
  }

  ${mediaQuery.large} {
    height: 40px;
    padding: 0 16px;
    font-size: 14px;
  }
`;

export default AgreementPage;
